import { render, staticRenderFns } from "./starting-point-simplified.vue?vue&type=template&id=7684b5a0&scoped=true&"
import script from "./starting-point-simplified.vue?vue&type=script&lang=ts&"
export * from "./starting-point-simplified.vue?vue&type=script&lang=ts&"
import style0 from "./starting-point-simplified.vue?vue&type=style&index=0&id=7684b5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7684b5a0",
  null
  
)

export default component.exports